
export default {
    profileReadBegin(state) {
        state.loading = true;
    },

    profileReadSuccess(state, data) {
        state.loading = false;
        state.data = data;
    },

    profileReadErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    setPasswordBegin(state) {
        state.loading = true;
    },

    setPasswordSuccess(state) {
        state.loading = false;
        //state.data = data;
    },

    setPasswordErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    socialProfileAddBegin(state) {
        state.loading = true;
    },

    socialProfileAddSuccess(state) {
        state.loading = false;
    },

    socialProfileAddErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    socialProfileUpdateBegin(state) {
        state.loading = true;
    },

    socialProfileUpdateSuccess(state) {
        state.loading = false;
    },

    socialProfileUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    userUpdateBegin(state) {
        state.loading = true;
        console.log("1-");
    },

    userUpdateSuccess(state) {
        state.loading = false;
        console.log("2-");
    },

    userUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    },
}